import { takeLatest } from 'redux-saga';
import { put } from 'redux-saga/effects';
import {
  LOGIN_SAP_LISTAR_BEGIN,
  LOGIN_SAP_LISTAR_SUCCESS,
  LOGIN_SAP_LISTAR_FAILURE,
  LOGIN_SAP_LISTAR_DISMISS_ERROR,
} from './constants';
import initialState from './initialState';
import * as Services from '../../../sdk/services';

export function listar(filter = {}) {
  // If need to pass args to saga, pass it with the begin action.
  return {
    type: LOGIN_SAP_LISTAR_BEGIN,
    filter,
  };
}

export function dismissListarError() {
  return {
    type: LOGIN_SAP_LISTAR_DISMISS_ERROR,
  };
}

// worker Saga: will be fired on LOGIN_SAP_LISTAR_BEGIN actions
export function* doListar(action) {
  // If necessary, use argument to receive the begin action with parameters.
  let res;
  try {
    const LoginSAPApi = new Services['LoginSAPApi']();
    res = yield LoginSAPApi.find(action.filter);
  } catch (err) {
    yield put({
      type: LOGIN_SAP_LISTAR_FAILURE,
      data: { error: err },
    });
    return;
  }
  // Dispatch success action out of try/catch so that render errors are not catched.
  yield put({
    type: LOGIN_SAP_LISTAR_SUCCESS,
    data: res,
  });
}

/*
  Alternatively you may use takeEvery.

  takeLatest does not allow concurrent requests. If an action gets
  dispatched while another is already pending, that pending one is cancelled
  and only the latest one will be run.
*/
export function* watchListar() {
  yield takeLatest(LOGIN_SAP_LISTAR_BEGIN, doListar);
}

// Redux reducer
export function reducer(state, action) {
  switch (action.type) {
    case LOGIN_SAP_LISTAR_BEGIN:
      return {
        ...state,
        listaLoginSap: initialState.listaLoginSap,
        listarPending: true,
        listarError: null,
      };

    case LOGIN_SAP_LISTAR_SUCCESS:
      return {
        ...state,
        listaLoginSap: action.data,
        listarPending: false,
        listarError: null,
      };

    case LOGIN_SAP_LISTAR_FAILURE:
      return {
        ...state,
        listarPending: false,
        listarError: action.data.error,
      };

    case LOGIN_SAP_LISTAR_DISMISS_ERROR:
      return {
        ...state,
        listarError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/login-sap/redux/listar.js